module.exports = __webpack_public_path__ + "img/mail.0b89aae3.svg";